import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { useDispatch, useSelector } from "react-redux";
import { set } from "../../actions";
import update from "immutability-helper";

const IOSSwitch = withStyles(theme => ({
    root: {
        width: 42,
        height: 26,
        padding: 0,
        margin: theme.spacing(1)
    },
    switchBase: {
        padding: 1,
        "&$checked": {
            transform: "translateX(16px)",
            color: theme.palette.common.white,
            "& + $track": {
                backgroundColor: "#52d869",
                opacity: 1,
                border: "none"
            }
        },
        "&$focusVisible $thumb": {
            color: "#52d869",
            border: "6px solid #fff"
        }
    },
    thumb: {
        width: 24,
        height: 24
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(["background-color", "border"])
    },
    checked: {},
    focusVisible: {}
}))(({ classes, ...props }) => (
    <Switch
        focusVisibleClassName={classes.focusVisible}
        disableRipple
        classes={{
            root: classes.root,
            switchBase: classes.switchBase,
            thumb: classes.thumb,
            track: classes.track,
            checked: classes.checked
        }}
        {...props}
    />
));

export default props => {
    return <></>;
    const therapist = useSelector(state => state.data.therapist);
    const dispatch = useDispatch();
    const [checked, setChecked] = useState(true);
    if (Number(therapist.trial) > Date.now() + 90 * 24 * 60 * 60 * 1000) return <></>;
    return (
        <FormGroup>
            <FormControlLabel
                control={
                    <IOSSwitch
                        checked={therapist.plan === "pro"}
                        onChange={() => {
                            setChecked(!checked);
                            window.localStorage.setItem("versionIndicator", therapist.plan === "pro" ? "" : "true");
                            const plan = window.localStorage.getItem("versionIndicator") ? "pro" : "light";
                            dispatch(set({ therapist: update(therapist, { plan: { $set: plan } }) }));
                        }}
                        name="checked"
                    />
                }
                label={checked ? "Pro Version" : "Light Version"}
                style={{ color: "black" }}
            />
        </FormGroup>
    );
};
